import React from 'react';
import TabSectionHeader from '../Elements/TabSectionHeader';

const ArticlesSection = () => (
  <section className="text-ink w-full flex flex-col min-h-[16rem]">
    <header className="mb-10">
      <TabSectionHeader tabIndex={5} />
      <p className="text-muted max-w-2xl">
        Deep dives into system architecture, local AI workflows, and
        high-throughput backend performance.
      </p>
    </header>
    <div className="flex flex-1 items-center justify-center">
      <div className="glass-card rounded-xl px-8 py-6 text-center">
        <p className="inline-flex items-center gap-2 font-mono text-lg text-ink">
          <span className="text-accent animate-pulse" aria-hidden="true">
            ●
          </span>
          Coming Soon
        </p>
        <p className="mt-2 text-sm text-muted">Drafts aren’t public yet.</p>
      </div>
    </div>
  </section>
);

export default ArticlesSection;
